import FileUpload from "./FileUploadContainer";

export default FileUpload;
